export const pinterest = [
  {
    rank: 1,
    name: "Pic1",
    description: "Post.",
    image: "https://i.pinimg.com/736x/29/ec/76/29ec7663bc0f9d5166d6f6859805f2c5.jpg",
    url: "https://i.pinimg.com/736x/29/ec/76/29ec7663bc0f9d5166d6f6859805f2c5.jpg",
  },
  {
    rank: 2,
    name: "Pic2",
    description: "Post.",
    image: "https://i.pinimg.com/736x/46/c0/46/46c04650b78516e8016b3f4d5fa905c1.jpg",
    url: "https://i.pinimg.com/736x/46/c0/46/46c04650b78516e8016b3f4d5fa905c1.jpg",
  },
  {
    rank: 3,
    name: "Pic3",
    description: "Post.",
    image: "https://i.pinimg.com/736x/ff/ea/55/ffea55eeac60e4e39828d70e04b853ae.jpg",
    url: "https://i.pinimg.com/736x/ff/ea/55/ffea55eeac60e4e39828d70e04b853ae.jpg",
  },
  {
    rank: 4,
    name: "Pic4",
    description: "Post.",
    image: "https://i.pinimg.com/736x/e2/d6/d6/e2d6d644e1214738bcd4ff407ed28db7.jpg",
    url: "https://i.pinimg.com/736x/e2/d6/d6/e2d6d644e1214738bcd4ff407ed28db7.jpg",
  },
  {
    rank: 5,
    name: "Pic5",
    description: "Post.",
    image: "https://i.pinimg.com/736x/56/d1/09/56d109557ab874092ef894e38ec963ed.jpg",
    url: "https://i.pinimg.com/736x/56/d1/09/56d109557ab874092ef894e38ec963ed.jpg",
  },
  {
    rank: 6,
    name: "Pic6",
    description: "Post.",
    image: "https://i.pinimg.com/736x/d9/86/d8/d986d8bf4d7a94c88a2e15c5103edb2c.jpg",
    url: "https://i.pinimg.com/736x/d9/86/d8/d986d8bf4d7a94c88a2e15c5103edb2c.jpg",
  },
  {
    rank: 7,
    name: "Pic7",
    description: "Post.",
    image: "https://i.pinimg.com/736x/ab/8b/6e/ab8b6e99ceb1de5d718214d460deaa91.jpg",
    url: "https://i.pinimg.com/736x/ab/8b/6e/ab8b6e99ceb1de5d718214d460deaa91.jpg",
  },
  {
    rank: 8,
    name: "Pic8",
    description: "Post.",
    image: "https://i.pinimg.com/736x/4c/5a/ac/4c5aacb3bcae0ed64ad6dfa64b250da5.jpg",
    url: "https://i.pinimg.com/736x/4c/5a/ac/4c5aacb3bcae0ed64ad6dfa64b250da5.jpg",
  },
    {
    rank: 9,
    name: "Pic9",
    description: "Post.",
    image: "https://i.pinimg.com/736x/30/3c/c5/303cc5576778aa51ef738481c367e348.jpg",
    url: "https://i.pinimg.com/736x/30/3c/c5/303cc5576778aa51ef738481c367e348.jpg",
  },
      {
    rank: 10,
    name: "Pic10",
    description: "Post.",
    image: "https://i.pinimg.com/736x/b6/b0/db/b6b0dbd1ce2439554a56eaa94c187c31.jpg",
    url: "https://i.pinimg.com/736x/b6/b0/db/b6b0dbd1ce2439554a56eaa94c187c31.jpg",
  },
        {
    rank: 11,
    name: "Pic11",
    description: "Post.",
    image: "https://i.pinimg.com/736x/37/d0/60/37d0607c643a6fe00c977815889bf2e1.jpg",
    url: "https://i.pinimg.com/736x/37/d0/60/37d0607c643a6fe00c977815889bf2e1.jpg",
  },
];
